import { colors, HSLColors, toHSLA } from '@design-system/styles'
import type { DefaultProps } from '@design-system/types/props'
import styled from '@emotion/styled'
import { typo } from '@mathflat/common/style'
import { s3URL } from '@mathflat/common/util'
import clsx from 'clsx'
import { observer } from 'mobx-react'

import commonRepo from '@/repository/common.repo'
import { scenarioService } from '@/service/scenario.service'

const ProfileFolder = () => {
  return (
    <S.Folder>
      <div className="box">
        <b className="box-title">
          {scenarioService.progressRate === 0
            ? `${commonRepo.appKorName} 완전정복`
            : `${commonRepo.appKorName} 이해도 ${scenarioService.progressRate}% 정복!`}
        </b>
        <div
          className="box-description"
          dangerouslySetInnerHTML={{
            __html:
              scenarioService.progressRate === 0
                ? `<span><b>${commonRepo.user?.name} 선생님</b>을<br/>위한 ${commonRepo.appKorName} 완전정복 4단계!</span>`
                : scenarioService.progressRate === 100
                  ? `<span><b>${commonRepo.user?.name}&nbsp;선생님</b><br/>벌써! 관리 잘하는 ${commonRepo.isSchoolflat ? '선생님' : '학원'}으로 입소문 났어요!<span>`
                  : scenarioService.nextScenario?.프로필.descHTML(commonRepo.user?.name ?? ''),
          }}
        />
      </div>
      <div className="progress-container">
        <ProgressItem className={clsx(scenarioService.progressRate >= 25 && 'is-active')} />
        <ProgressItem className={clsx(scenarioService.progressRate >= 50 && 'is-active')} />
        <ProgressItem className={clsx(scenarioService.progressRate >= 75 && 'is-active')} />
        <ProgressItem className={clsx(scenarioService.progressRate >= 100 && 'is-active')} />
      </div>
    </S.Folder>
  )
}

export default observer(ProfileFolder)

const ProgressItem = ({ style, className }: DefaultProps) => {
  return <S.ProgressItem style={style} className={clsx('scenario-progress-item', className)} />
}
const S = {
  Folder: styled.div`
    width: 280px;
    height: 143px;
    padding: 31px 10px 14px 10px;
    background: no-repeat
      url(${s3URL.mathflatAssetsBucket.teacher('images/scenario/scenario_profile_folder.svg')});
    background-position: top left;
    background-size: 280px 143px;
    background-origin: border-box;
    ${typo.caption01};

    .box {
      display: flex;
      justify-content: center;
      flex-direction: column;
      background: ${toHSLA({ ...HSLColors.blue.$300, a: 0.1 })};
      border-radius: var(--Radius-100);
      text-align: center;
      padding: 8px;
    }
    .box-title {
      color: ${colors.blue.$300};
    }
    .box-description {
      display: flex;
      flex-direction: column;
    }
    .progress-container {
      display: flex;
      gap: 2px;
      width: 100%;
      padding: 0 3px;
      margin-top: 8px;
      .scenario-progress-item {
        &:first-of-type {
          border-radius: var(--Radius-100) 0px 0px var(--Radius-100);
        }
        &:last-of-type {
          border-radius: 0px var(--Radius-100) var(--Radius-100) 0px;
        }
      }
    }
  `,
  ProgressItem: styled.div`
    width: 62px;
    height: 20px;
    background-color: ${colors.blue.$200};
    border: 1px solid ${colors.blue.$300};
    opacity: 0.1;

    box-shadow: 0px 4px 10px rgba(47, 150, 200, 0.4);
    &:nth-of-type(2) {
      background-color: ${colors.blue.$300};
      border-color: ${colors.blue.$400};
    }
    &:nth-of-type(3) {
      background-color: ${colors.blue.$400};
      border-color: #0776dd;
    }
    &:nth-of-type(4) {
      background-color: ${colors.subPurple};
      border-color: #5a5fac;
    }
    &.is-active {
      opacity: 1;
    }
  `,
}
